import React, { useContext } from "react";
import "./ExerciseList.scss";
import aurum from "../../../assets/images/aurum.png";
import exercise from "../../../assets/images/exercise.png";
import UserContext from "../../../services/context/userContext";
import Icon from "../../_default/Icon";
import { Link, useHistory, useParams } from "react-router-dom";
// import { FaFeather } from "react-icons/fa";
import FeatherIcon from "feather-icons-react";
import ProfilePopup from "../../_default/Popup/ProfilePopup";
import { useState } from "react";
import Popup from "../../_default/Popup";
import { deleteClient, deletePending } from "../../../services/firebase/firestore/deleteData";
import Loading from "../../_default/Loading";
export default function ExerciseListItem({ clientPlusAdminExercises, clients ,loading,setLoading,client, activeClient, setlogging, exercise, idx, removeExercise, from, ...props }) {
  // console.log("clientPlusAdminExercises",clientPlusAdminExercises)
  const history=useHistory()
  const user = useContext(UserContext);
  let {id}=useParams()
  // console.log("exercisessss",exercise)
  let [profileData,setProfileData]=useState(false)
  const [deleteClientPopup,setDeleteClientPopup]=useState(false)
  // let [loading,setLoading]=useState(false)
  let handleProfile
  let gotoClientOverview=(selectClientId)=>{
    window.location.href = '/clients/' + selectClientId;
  }
  // console.log("pending clients",client)
  let removeClient = (clientId) => {
    // setDeleteClientPopup(true)
    setLoading(true)
		// debugger
		
    if(client.id){
      // debugger
      deleteClient(client.id, res => {
        console.log("dele res", res)
        if (res) {
          // window.location.href = "/clients/" + clients[clients.length - 2].id
          setDeleteClientPopup(false)
          
          setLoading(false)
        } else {
          // window.location.href = "/clients/" + clients[clients.length - 1].id
          setLoading(false)
          setDeleteClientPopup(false)
        }
      })
    }else{
      deletePending(client.client_email, res => {
        // debugger
        // console.log("dele res", res)
        if(res){
          
          setDeleteClientPopup(false)
          setLoading(false)
          // window.location.href = "/clients/"+id
        }else{
          setLoading(false)
          // debugger
          setDeleteClientPopup(false)
          // window.location.href = "/clients/"+id
  
        }
        
      })
    }
		
	}
  return (
    <div className={activeClient?deleteClient?"c-exercise-list-item-delete-client":"c-exercise-list-item-active-client":"c-exercise-list-item"} key={idx}>
      <>
        {
          activeClient ?
            <>
            
            {/* <Link to={`/clients/${client.id}`} style={{ textDecoration: 'none', color: 'black' }}> */}
          
             {localStorage.setItem("tabIndex",0)}
            <div className={deleteClient?"c-exercise-list-item-data-delete-client":"c-exercise-list-item-data-active-client"}  >


             {client.image ? <div className="c-exercise-image" style={{ backgroundImage: `url('${client.image}')` }} /> :
               <div className="c-exercise-image" style={{backgroundColor:"unset"}}> <Icon icon="users" /></div>
             }
             <div className="c-exercise-text" style={{ display: "contents" }} onClick={()=>gotoClientOverview(client.id)}>
               <h3 className="client-name">{client.first_name?client.first_name + " " + client.last_name:client.client_email}</h3>
               <p className="client-p-tag-email"  >{client.email?client.email:client.client_email}</p>
               <p className="client-p-tag">{client.date_of_birth?.toDate().getDate()}/{client.date_of_birth?.toDate().getMonth() + 1}/{client.date_of_birth?.toDate().getFullYear()}</p>
               <p className="client-p-tag">{client.gender?client.gender:"Not mentioned"}</p>
               <div className='client-measurements' style={{ display: "flex" }}>
                 <p className="client-weight" >{client.measurements?client.measurements.weight +" "+ "kg":"----"}</p>
                 <p className="client-height" >{client.measurements?client.measurements.length +" "+ "cm":<span style={{fontSize:"13px",fontWeight:"700"}}>Not added</span>}</p>

               </div>
             </div>
             <button style={{cursor:"pointer"}} onClick={()=>{setDeleteClientPopup(true)}}>

               <Icon icon="trash"  size={20} height={20} />
             </button>

           </div>
            
          
              
              {/* </Link> */}


            </> :
            <>
              <Link style={{ textDecoration: 'none', color: 'black' }} to={setlogging ? `/logging/${exercise.id}` : {
                pathname: `/exercise/${exercise.id}?update=true`,
                search: "?update=true",
                state: { update: true, exercise: exercise }
              }}

              >



                <div className="c-exercise-list-item-data">

                  <div className="c-exercise-image" style={{ backgroundImage: `url('${exercise.image}')` }} />
                  <div className="c-exercise-text">
                    <h3>{exercise.name}</h3>
                    <span>{exercise.category}</span>
                  </div>

                </div>
              </Link>
              {/* {from === "aurum" ?
                
                : ""} */}

              <div className="c-exercise-icons">
                {from === "aurum" ? (
                  <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
                  <Link style={{ textDecoration: 'none', color: 'black' }} to={{
                    pathname: `/exercise/coptotrainee/${exercise.id}`,
                    search: "?copy=true",
                    state: { copy: true, exercise: exercise }
                }}>
                  {/* <span style={{fontWeight:"500"}}>Copy to trainer account</span> */}
                  <div
                    className="copy-btn"
                    style={{marginRight:"10px"}}
                  >
                    {/* Copy to trainer account */}
                    Copy
                    <FeatherIcon icon="copy" size="13" color="#000" />
                  </div>
                </Link>
                    <div className="c-exercise-user-image" style={{ backgroundImage: `url('${aurum}')` }} />
                  </div>
                ) : (
                  <div className="c-exercise-user-image" style={{ backgroundImage: `url('${user.image}')` }}>
                    {user.image === "" && <p>{user.first_name[0] + user.last_name.match(/\b(\w)/g).join("")}</p>}
                  </div>
                )}

                {
                  clientPlusAdminExercises?
                  
                  <div className="c-exercise-btns">
                  {from === "aurum" && !user.admin ? (
                    <></>
                  ) : (
                    
                    
                    <>
                     <button onClick={() => props.history.push("/exercise/"+exercise.id, { update: true, from: from, exercise })}>
                     <Icon icon="edit" size={20} height={20} />
                   </button>
                   <button
                     onClick={(e) => {
                       e.stopPropagation();
                       removeExercise(exercise);
                     }}
                   >
                     <Icon icon="trash" size={20} height={20} />
                   </button>
                    </>
                   
                     
                 
                  )}
                </div>:""
                }
                
              </div>
            </>
        }
      </>
      {profileData && (
            <ProfilePopup
              onCancel={() => setProfileData(false)}
              deletePopup={true}
              client_detail={client}
              time={"2023-02-23"}
            />
          )}
          {
            deleteClientPopup&&
            <Popup 
            title={"Delete Client"}
            button="Delete"
            deletePopup={true}
            description={"Are you sure you want to delete this Client? This can not be undone."}
            // onAction={removeClient}
            onCancel={() => {
              setDeleteClientPopup(false);
            }}
            onAction={removeClient}

            />
          }
    </div>
  );
}
//onClick={() => props.history.push("/exercise/"+exercise.id, { update: true, from: from, exercise })}


// save for later use
{/* <div className="c-exercise-btns">
{from === "aurum" && !user.admin ? (
  <></>
) : (
  <>
  {clientPlusAdminExercises?"--":
  <>
   <button>
   <Icon icon="edit" size={20} height={20} />
 </button>
 <button
   onClick={(e) => {
     e.stopPropagation();
     removeExercise(exercise);
   }}
 >
   <Icon icon="trash" size={20} height={20} />
 </button>
  </>
  }
   
  </>
)}
</div> */}